import type { SubEvaluation, TextProperty } from '@/teoCore/TeoApi';
import type {
  MarkerPillData,
  MarkerPillPerspectiveData,
  MarkerPillType,
} from '@/ui/elements/tpi-drawer/dimensionCard/DimensionCard.svelte';
import type { PillGroup } from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';

export function createMarkerPillData(
  id: string,
  key: string,
  textProp: TextProperty,
): MarkerPillData {
  return {
    id,
    key,
    type: 'MarkerPillData',
    label: textProp.title,
    value: textProp.num,
  };
}

export function createMarkerPillPerspectiveData(
  id: string,
  key: string,
  textProp: TextProperty,
  personalWords: TextProperty | undefined,
): MarkerPillPerspectiveData {
  const personalWordsNum = personalWords?.num ?? 0;
  return {
    id,
    key,
    type: 'MarkerPillPerspectiveData',
    labelSender: 'Sender',
    labelReceiver: 'Empfänger',
    valueSender: personalWordsNum === 0 ? 0 : 100 - textProp.num,
    valueReceiver: textProp.num,
  };
}

export function createPillGroupsFromIndices(indices: Record<string, SubEvaluation>): PillGroup[] {
  const pillGroups: PillGroup[] = [];

  let uniqueGroupId = 0;

  for (const iKey in indices) {
    const pills: (MarkerPillData | MarkerPillPerspectiveData)[] = [];
    const index = indices[iKey];

    if (index) {
      let uniquePillId = 0;

      for (const tpKey in index.text_properties) {
        const textProp = index.text_properties[tpKey];

        if (textProp) {
          const type: MarkerPillType =
            textProp.title.includes('(Sender/Empfänger)') ?
              'MarkerPillPerspectiveData'
            : 'MarkerPillData';
          const pill: MarkerPillData | MarkerPillPerspectiveData =
            type === 'MarkerPillData' ?
              createMarkerPillData(String(uniquePillId++), tpKey, textProp)
            : createMarkerPillPerspectiveData(
                String(uniquePillId++),
                tpKey,
                textProp,
                index.text_properties['personal_words'],
              );
          pills.push(pill);
        }
      }

      const pg: PillGroup = {
        id: String(uniqueGroupId++),
        key: iKey,
        label: index.title ?? 'unknown',
        used: index.used ?? false,
        score: index.score,
        pills: pills,
      };

      pillGroups.push(pg);
    }
  }

  return pillGroups;
}
